
import { Datasource } from './common';
const api = new Map<string, Promise<Datasource>>();
export default api;
api.set('cdnjs', import('./cdnjs'));
api.set('clojure', import('./clojure'));
api.set('crate', import('./crate'));
api.set('dart', import('./dart'));
api.set('docker', import('./docker'));
api.set('galaxy', import('./galaxy'));
api.set('git-refs', import('./git-refs'));
api.set('git-submodules', import('./git-submodules'));
api.set('git-tags', import('./git-tags'));
api.set('github-releases', import('./github-releases'));
api.set('github-tags', import('./github-tags'));
api.set('gitlab-tags', import('./gitlab-tags'));
api.set('go', import('./go'));
api.set('gradle-version', import('./gradle-version'));
api.set('helm', import('./helm'));
api.set('hex', import('./hex'));
api.set('maven', import('./maven'));
api.set('npm', import('./npm'));
api.set('nuget', import('./nuget'));
api.set('orb', import('./orb'));
api.set('packagist', import('./packagist'));
api.set('pod', import('./pod'));
api.set('pypi', import('./pypi'));
api.set('ruby-version', import('./ruby-version'));
api.set('rubygems', import('./rubygems'));
api.set('sbt-package', import('./sbt-package'));
api.set('sbt-plugin', import('./sbt-plugin'));
api.set('terraform-module', import('./terraform-module'));
api.set('terraform-provider', import('./terraform-provider'));
